/* globals MediaRecorder */
import { compose, onlyUpdateForKeys } from 'recompose'
import BaseComponent from '../BaseComponent'
import PropTypes from 'prop-types'
import React from 'react'
import injectSheet from 'react-jss'
import videoStyles from '../styles/video'

const VideoPlayElement = compose(
	onlyUpdateForKeys([]),
	injectSheet(videoStyles)
)(({ classes, videoRef, wrapperEl, setWrapperEl, src, loop }) =>
	<div
		className={classes.wrapper}
		ref={div => {
			if (div) {
				div.style.height = `${div.getBoundingClientRect().width}px`
			}
		}}
	>
		{/* Muted to autoplay on Android: https://stackoverflow.com/a/40718904 */}
		<video
			ref={videoRef}
			autoPlay
			className={classes.video}
			src={src}
			loop={loop}
			muted
		/>
	</div>
)

class Record extends BaseComponent {
	componentDidMount() {
		if (this.props.onComplete) {
			this.video.addEventListener('ended', this.props.onComplete)
		}
		if (this.props.blobs) {
			const superBuffer = new Blob(this.props.blobs, { type: 'video/webm' })
			this.video.src = window.URL.createObjectURL(superBuffer)
		}
	}

	render() {
		return (
			<div>
				<VideoPlayElement
					loop={this.props.loop}
					src={this.props.src}
					videoRef={video => {
						this.video = video
					}}
				/>
			</div>
		)
	}
}

Record.propTypes = {
	src: PropTypes.string,
	loop: PropTypes.bool,
	blobs: PropTypes.arrayOf(PropTypes.object),
	onComplete: PropTypes.func
}
export default Record



// WEBPACK FOOTER //
// ./src/components/Play.js